module.exports = __webpack_public_path__ + "arrow-left.svg?8ca4cceac80631d8ef93734a5399193c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-left.svg
// module id = 616
// module chunks = 0